var _path, _line, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 50,
    viewBox: "0 0 80 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1064 9.37696C25.1064 9.19687 25.2524 9.05087 25.4325 9.05087H42.0689C42.249 9.05087 42.395 9.19687 42.395 9.37696V19.624C42.395 24.3981 38.5248 28.2683 33.7507 28.2683C28.9766 28.2683 25.1064 24.3981 25.1064 19.624V9.37696Z",
    stroke: "black",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 25.0693,
    y1: 15.7307,
    x2: 42.429,
    y2: 15.7307,
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2053 42.9999C46.653 42.9999 46.2053 42.5522 46.2053 41.9999V40.778C46.2053 36.3597 42.6235 32.778 38.2053 32.778L29.2725 32.778C24.8542 32.778 21.2725 36.3597 21.2725 40.778L21.2725 41.9999C21.2725 42.5522 20.8247 42.9999 20.2725 42.9999C19.7202 42.9999 19.2725 42.5522 19.2725 41.9999L19.2725 40.778C19.2725 37.4783 20.8707 34.5518 23.3353 32.7305C25.6004 31.0566 28.5877 30.9999 31.4042 30.9999H36.0736C38.8901 30.9999 41.8774 31.0566 44.1425 32.7305C46.607 34.5518 48.2053 37.4783 48.2053 40.778V41.9999C48.2053 42.5522 47.7575 42.9999 47.2053 42.9999Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.74 38.9127L28.4407 32.622",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7402 38.9123L38.9084 32.248",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5816 1H9.78164C7.79342 1 6.18164 2.34315 6.18164 4V46C6.18164 47.6569 7.79342 49 9.78164 49H74.5816C76.5699 49 78.1816 47.6569 78.1816 46V4C78.1816 2.34315 76.5699 1 74.5816 1Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0908 8.63638L69.4545 8.63638",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0908 15.1819L69.4545 15.1819",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7275 21.7272L69.4547 21.6895",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7275 36.0199H69.4548",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7275 41.8057L69.4548 41.8057",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81836 9.63647H1.81836",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81836 19.6365H1.81836",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81836 29.6365H1.81836",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81836 39.6365H1.81836",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13.7275,
    y1: 1,
    x2: 13.7275,
    y2: 49,
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainDoc);
export default __webpack_public_path__ + "static/media/main_doc.15b3ecfa88c65556670992c040ab4e8d.svg";
export { ForwardRef as ReactComponent };